import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    ProductType,
} from 'app/enums/label.enums'
import {
    SCPreBookingsFilterRequestResponse,
} from './PreBookings.types'

const config: SkyNetTableConfig<keyof SCPreBookingsFilterRequestResponse> = {
    name: 'PreBookings',
    fields: [
        {
            name: 'preBookingNumber',
            labelKey: 'Prebooking.number',
            sorting: false,
        },
        {
            name: 'originAirportIataCode',
            filterField: 'originAirportIataCode',
            filterType: FilterType.Array,
            labelKey: 'Prebooking.originAirport',
            sorting: false,
        },
        {
            name: 'destinationAirportIataCode',
            filterField: 'destinationAirportIataCode',
            filterType: FilterType.Array,
            labelKey: 'Prebooking.destinationAirport',
            sorting: false,
        },
        {
            name: 'customerExecution',
            filterType: FilterType.Array,
            filterField: 'customerExecution',
            labelKey: 'Prebooking.customerExecution',
            sorting: false,
            minWidth: '30%',
        },
        {
            name: 'requestedHandover',
            labelKey: 'Prebooking.requestedHandover',
            filterField: 'requestedHandover',
            filterType: FilterType.DateRange,
            componentName: 'DateTimeCell',
            sorting: false,
            width: '200px',
        },
        {
            name: 'requiredContainers',
            componentName: 'RequiredContainersList',
            allowedValuesEnum: ProductType,
            sorting: false,
            labelKey: 'Prebooking.requiredContainers',
            filterField: 'requiredContainersProductType',
            filterType: FilterType.Array,
        },
    ],
}

export default config
